import { type RPPDomain } from '@retailer-platform/dashboard/core'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'sandbox',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component.
    // Reuses the existing Storefront (SFP) Totem entity — no dedicated sandbox entity needed yet.
    tool: 'storefront-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  // Route registration deferred until the domain has real content — mounting the
  // scoped router now would match `/sandbox` and render DashSwitch's 404 fallback.
  routers: {},
  navigationEntries: [],
  adminNavigationEntries: [],
}

export default definition
